module.exports = __webpack_public_path__ + "img/email_icon.12d353c3.png";